import React, { useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    CircularProgress,
    Container,
} from '@mui/material';

function ContactPage() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
    });
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus('');
        let url =
            process.env.REACT_APP_AWS_APIGATEWAY_URL ||
            process.env.REACT_APP_LOCAL_API_URL;
        try {
            const response = await fetch(url + '/contact/SendContactEmail', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setStatus('E-Mail erfolgreich gesendet!');
            } else {
                const errorData = await response.json();
                setStatus(`Failed to send email: ${errorData.message}`);
            }
        } catch (error) {
            setStatus(
                'Versäumnis, E-Mails zu senden. Bitte versuchen Sie es erneut.',
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    maxWidth: 500,
                    mx: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    mt: 4,
                }}
            >
                <Typography variant="h4" align="center">
                    Kontakt
                </Typography>
                <TextField
                    label="Ihr Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    fullWidth
                />
                <TextField
                    label="E-Mail Adresse"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    fullWidth
                />
                <TextField
                    label="Nachricht"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    fullWidth
                    multiline
                    rows={4}
                />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} /> : 'Schicken'}
                </Button>
                {status && (
                    <Typography
                        variant="body2"
                        color={status.includes('erfolgreich') ? 'green' : 'red'}
                        align="center"
                    >
                        {status}
                    </Typography>
                )}
                <Box sx={{ mt: 3, p: 2, border: '1px dashed gray' }}>
                    <Typography variant="body1">
                        Wenn Sie Probleme mit der Nutzung haben oder weitere
                        Vorschläge haben, füllen Sie bitte das obige Formular
                        aus.
                    </Typography>
                </Box>
            </Box>
        </Container>
    );
}

export default ContactPage;
